'use client'

import * as React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import {
  Box,
  ClipboardList,
  DollarSign,
  Frame,
  LayoutDashboard,
  LifeBuoy,
  Map,
  Package,
  PieChart,
  Send,
  Settings2,
  ShoppingBag,
  User,
  UserCheck,
  Users,
  Wallet,
} from 'lucide-react'
import { Logo } from '@/components/logo'
import { NavMain } from '@/components/nav-main'
import { NavProjects } from '@/components/nav-projects'
import { NavSecondary } from '@/components/nav-secondary'
import { NavUser } from '@/components/nav-user'
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@/components/ui/sidebar'
import { useAuthStore } from '@/stores/auth-store'
import { API_BASE_URL } from '@/lib/axios'

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const { t } = useTranslation()
  const user = useAuthStore((state) => state.user)

  const navMain = [
    {
      title: t('nav.dashboard'),
      url: '/',
      icon: LayoutDashboard,
      isActive: true,
    },
    {
      title: t('nav.companyExpenses'),
      url: '/company-expenses',
      icon: Wallet,
    },
    {
      title: t('nav.personalExpenses'),
      url: '/personal-expenses',
      icon: User,
    },
    {
      title: t('nav.workers'),
      url: '/workers',
      icon: Users,
    },
    {
      title: t('nav.customers'),
      url: '/customers',
      icon: UserCheck,
    },
    {
      title: t('nav.orders'),
      url: '/orders',
      icon: ClipboardList,
    },
    {
      title: t('nav.products'),
      url: '/products',
      icon: Box,
    },
    {
      title: t('nav.sell'),
      url: '/sell',
      icon: ShoppingBag,
    },
    {
      title: t('nav.materials'),
      url: '/materials',
      icon: Package,
      items: [
        {
          title: t('nav.materialIncomes'),
          url: '/material-incomes',
        },
      ],
    },
    {
      title: t('nav.pricing'),
      url: '/pricing',
      icon: DollarSign,
    },
  ]

  const getAvatarUrl = (avatar: string | null) => {
    if (!avatar) return ''
    if (avatar.startsWith('http')) return avatar
    // Remove /api from base URL and append avatar path
    const baseUrl = API_BASE_URL.replace(/\/api$/, '')
    return `${baseUrl}${avatar}`
  }

  const userData = {
    name: user ? `${user.first_name} ${user.last_name}` : 'User',
    email: user?.email || '',
    avatar: getAvatarUrl(user?.avatar || null),
  }

  return (
    <Sidebar variant='inset' {...props}>
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton size='lg' asChild>
              <Link to='/'>
                <span className='flex items-center'>
                  <Logo className='h-8 w-auto text-sidebar-primary' />
                </span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={navMain} />
        {/* <NavProjects projects={data.projects} />
        <NavSecondary items={data.navSecondary} className='mt-auto' /> */}
      </SidebarContent>
      <SidebarFooter>
        <NavUser user={userData} />
      </SidebarFooter>
    </Sidebar>
  )
}
